module.exports = __webpack_public_path__ + "static/media/pagine.6d5ffcac.svg";